export const REDACT_EXTENSION_KEY = 'redacted-scribble';

export const REDACT_EXTENSION_TYPE = 'com.rovo.guard';
